import React from 'react';
import { usePrecosRotas, ORIGEM, brl } from '../lib/precosRotas';

const PricingExamples = () => {
  const rotas = usePrecosRotas();
  if (!rotas || rotas.length === 0) return null;
  return (
    <section id="economia" className="bg-[#F6F8FC] py-[70px] lg:py-[110px] scroll-mt-20">
      <div className="max-w-[1240px] mx-auto px-5 lg:px-8">
        <h2 className="text-center text-[30px] lg:text-[44px] font-black tracking-tight leading-tight text-slate-900">Quanto você <span className="inn-text-gradient">economiza</span></h2>
        <p className="text-center text-slate-500 text-base lg:text-[19px] mt-3">Saindo de {ORIGEM.nome}, pelo PAC:</p>
        <div className="max-w-[760px] mx-auto mt-10 lg:mt-12 bg-white rounded-3xl shadow-[0_12px_40px_rgba(15,23,42,0.07)] overflow-hidden">
          {rotas.map((r) => (
            <div key={r.cep} className="grid grid-cols-[1fr_auto] sm:grid-cols-[1fr_auto_auto] items-center gap-x-4 sm:gap-x-7 gap-y-0.5 px-5 sm:px-8 py-4 sm:py-5 border-b border-slate-100 last:border-b-0">
              <span className="text-[15px] sm:text-[17px] row-span-2 sm:row-span-1"><b className="font-extrabold">{ORIGEM.nome}</b><span className="text-slate-400 mx-2">→</span><b className="font-extrabold">{r.nome}</b></span>
              {r.balcao > r.valor ? <s className="text-slate-400 text-sm sm:text-[15px] text-right">R$ {brl(r.balcao)}</s> : <span />}
              <span className="text-[#F77820] font-black text-[21px] sm:text-2xl text-right">R$ {brl(r.valor)}</span>
            </div>
          ))}
        </div>
        <p className="text-center text-slate-400 text-[13px] mt-4">Valores do balcão riscados. PAC, pacote de 16x11x2 cm e 0,3 kg. Sujeito a alteração.</p>
      </div>
    </section>
  );
};

export default PricingExamples;
